import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

// material-ui icons
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import TableImportHistory from './TableImportHistory'

const style = {
    customCardContentClass: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    }
};

function ImportContainer({ ...props }) {
    return (
        <Card>
            <CardBody>
                <GridContainer>
                    <GridItem xs={12}>
                        <TableImportHistory />
                    </GridItem>
                </GridContainer>
            </CardBody>
        </Card>
    )
}

export default withStyles(style)(ImportContainer);